import { stableSort, getSorting, formatDateLong, } from '../../../Functions';

export function VesselArrivalNotice(XLSX, data) {
    var wb = XLSX.utils.book_new();

    // data.forEach((element, id) => {
        var ws = XLSX.utils.json_to_sheet(
            [
                { A: '', B: 'OCEAN TRANSPORT GROUP OF COMPANIES INC.' },
                { A: '', B: 'Vessel: ' + data[0][0].vessel, },
                { A: '', B: 'Voyage: ' + data[0][0].voyage, },
                { A: '' },
                { 
                    A: 'NO',
                    B: 'BOOKING REF', 
                    // C: 'OLD BOOKING REF', 
                    D: 'WAYBILL REF', 
                    // E: 'OLD WAYBILL REF', 
                    F: 'SHIPPER', 
                    G: 'SHIPPER PREFERRED NAME', 
                    H: 'CONSIGNEE', 
                    I: 'CONSIGNEE PREFERRED NAME', 
                    J: 'ORIGIN', 
                    K: 'DESTINATION', 
                    L: 'ATD', 
                    M: 'ETD', 
                    N: 'CONTAINER VAN', 
                    O: 'SEAL #', 
                    P: 'COMMODITY', 
                    Q: 'REMARKS' 
                }
            ]
            , { header: [], skipHeader: true });
        let count = 0;
        data.forEach((element) => {
        stableSort(element, getSorting('asc', 'shipper')).forEach((ele, id) => {
            count++;
            var ATDATE = new Date(ele.actualTimeDeparture);
            // var ETDATE = new Date(ele.etd);
            XLSX.utils.sheet_add_json(ws, [
                {
                    A: count,
                    B: ele.bookingRef, 
                    // C: ele.oldBookingRef, 
                    D: ele.wayBillRef, 
                    // E: ele.oldWaybillRef, 
                    F: ele.shipper, 
                    G: ele.shipperPreferedName, 
                    H: ele.consigneeName, 
                    I: ele.consigneePreferedName, 
                    J: ele.origin, 
                    K: ele.destination, 
                    L: formatDateLong(ATDATE), 
                    // M: formatDateLong(ETDATE), 
                    M: "", 
                    N: ele.cargo, 
                    O: ele.sealNum, 
                    P: ele.goods, 
                    Q: ele.remarks 
                }
            ], { header: [], skipHeader: true, origin: -1 });
        });
        });
        var wscols = [
            { wch: 6 }, // Number
            { wch: 15 }, // booking ref
            // { wch: 15 }, // old booking ref
            { wch: 15 }, // waybill
            // { wch: 15 }, // old waybill ref
            { wch: 35 }, // shipper
            { wch: 25 }, // shipper preferred name
            { wch: 35 }, // consignee
            { wch: 25 }, // consignee preferred name
            { wch: 8 }, // origin
            { wch: 12 }, // destination
            { wch: 16 }, // atd
            { wch: 16 }, // etd
            { wch: 15 }, // container
            { wch: 13 }, // sealnum
            { wch: 20 }, // goods
            { wch: 35 }, // remark
        ];
        ws['!cols'] = wscols;
        
        XLSX.utils.book_append_sheet(wb, ws, "Vessel Arrival Notice");

    // });

    XLSX.writeFile(wb, "Vessel_Arrival_Notice.xlsx");
};